module.exports = __webpack_public_path__ + "img/usage_card1.fe1b9518.png";